import classnames from 'classnames'
import React from 'react'
import { selectShouldDisplayMapTools } from '../../../store/ui/ui.selectors'
import { isGE } from '../../Device'
import logoMappy from '../../genericComponents/logo-mappy-bordered.svg'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import s from './Logo.less'

const Logo = () => (
  <div className={classnames(s.Logo, isGE() ? s.centeredBottomLogo : 'maplibregl-ctrl-top-left')}>
    <img src={logoMappy} width="84" height="22" />
  </div>
)

export default withEverySelectorTruthy(selectShouldDisplayMapTools())(Logo)
